import { render, staticRenderFns } from "./PrintLabelsModal.vue?vue&type=template&id=732f5150&scoped=true"
import script from "./PrintLabelsModal.vue?vue&type=script&lang=ts"
export * from "./PrintLabelsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732f5150",
  null
  
)

export default component.exports